// Sepet önerisi (snippets/elsa-cart-upsell): "Ekle" ile ürünü sepete ekler.
// Temanın çekmecesi ve sayaç rozeti CartLinesUpdateEvent ile güncellenir (elsa-home.js ile aynı yöntem).
import { CartLinesUpdateEvent } from '@shopify/events';

if (!window.__elsaUpsell) {
  window.__elsaUpsell = true;
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  const fetchCart = async () => {
    const comp = document.querySelector('cart-items-component');
    if (comp) {
      await customElements.whenDefined('cart-items-component');
      if (typeof comp.fetchCartData === 'function') return comp.fetchCartData();
    }
    return fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } }).then((r) => r.json());
  };

  document.addEventListener('click', async (ev) => {
    const btn = ev.target.closest('[data-elsa-upsell]');
    if (!btn) return;
    ev.preventDefault();
    const id = Number(btn.dataset.elsaUpsell);
    if (!id || btn.classList.contains('is-loading')) return;
    btn.classList.add('is-loading');

    const sectionIds = [...document.querySelectorAll('cart-items-component')]
      .map((c) => c.dataset.sectionId)
      .filter(Boolean);
    let deferred;
    try {
      deferred = CartLinesUpdateEvent.createPromise();
      btn.dispatchEvent(
        new CartLinesUpdateEvent({
          action: 'add',
          context: 'cart',
          lines: [{ merchandiseId: id, quantity: 1 }],
          promise: deferred.promise,
        })
      );
    } catch (_) {
      deferred = null;
    }

    try {
      const res = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id, quantity: 1 }], sections: sectionIds.join(',') }),
      });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || data.message);
      const cart = await fetchCart();
      deferred?.resolve({
        cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
        detail: { items: cart.items, source: 'elsa-upsell', itemCount: 1, sections: data.sections, didError: false },
      });
    } catch (_) {
      btn.classList.remove('is-loading');
      deferred?.resolve({ cart: null, detail: { didError: true, source: 'elsa-upsell', itemCount: 0 } });
      location.href = btn.closest('.elsa-upsell__item')?.querySelector('a')?.href || `${root}cart`;
    }
  });
}
